<template>
  <div class="max-w-3xl mx-auto text-center">
    <h1 class="text-2xl font-bold">Perfect, thanks. What are your primary goals right now?</h1>
    <p class="text-lg mb-4">Select what matters most to your team so we can tailor our solutions.</p>
    <FormKit type="form" @submit="$emit('next')" class="mt-8" v-model="formData" :actions="false">
      <FormKit
        name="teamFocus"
        :options="[
          'Hire more agents',
          'Increase per-agent productivity',
          'Decrease agent turnover',
          'Improve your abiliity to onboard new agents',
          'Level up your agents',
          'Level up you or your leadership team',
        ]"
        type="checkbox"
      />
      <FormKit type="submit" label="Continue" class="btn btn-primary" />
    </FormKit>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    companyTypes() {
      return 'agents';
    },
    formData: {
      set(newData) {
        this.$store.commit('onboarding/setTeam', newData);
      },
      get() {
        return this.team;
      },
    },
    ...mapState({
      team: state => state.onboarding.team,
    }),
  },
};
</script>

<style></style>
